import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSnackbar } from 'notistack';
import { ScheduleService } from 'services/ScheduleService';
import { ShiftProfileGroupCreate } from 'repository/schedule/@types/ShiftProfileGroup';
import { FormShiftProfileGroup } from './FormShiftProfileGroup';
import { ShiftProfileGroupFormValues } from 'schemas/ShiftProfileGroup';

interface CreateProps {
    open: boolean;
    setOpen: (open: boolean) => void;
    rows: any;
    reloading: () => void;
}

const scheduleService = new ScheduleService();

export const CreateShiftProfileGroup: FC<CreateProps> = ({ open, setOpen, rows, reloading }) => {
    const { t } = useTranslation();
    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values: ShiftProfileGroupFormValues) => {
        const payload: ShiftProfileGroupCreate = {
            shift_profile_group_name: values.name,
            shift_profile_group_description: values.description || '',
            shift_profiles: values.items.map((it) => ({
                shift_profile_id: it.shift_profile_id as number,
                monday: it.monday,
                tuesday: it.tuesday,
                wednesday: it.wednesday,
                thursday: it.thursday,
                friday: it.friday,
                saturday: it.saturday,
                sunday: it.sunday,
            })),
        };

        try {
            await scheduleService.shift_profile_group.create(payload);
            enqueueSnackbar('Grupo de perfil de turno creado', { variant: 'success' });
            reloading();
        } catch (error) {
            console.error(error);
            enqueueSnackbar(t('general.errors.unexpected'), { variant: 'error' });
            throw error;
        }
    };

    return (
        <FormShiftProfileGroup
            open={open}
            setOpen={setOpen}
            rows={rows}
            titleKey={'Nuevo grupo de perfil de turno'}
            submitLabel={'Crear grupo'}
            onSubmit={handleSubmit}
        />
    );
};
